import React, { useEffect, useState } from "react";
import "./expertise.css";
// 1. Import useNavigate from react-router-dom
import { useNavigate } from "react-router-dom";

const expertise = [
  {
    title: "Superior Risk Management",
    text: "Risk management isn’t a step in our process — it is the foundation.",
    desc: "At Ladderup, we believe the only sustainable way to protect capital and generate consistent returns is through robust risk management. It's not treated as a standalone function but is deeply embedded into every layer of our advisory approach — from asset allocation to product selection and portfolio construction.",
    link: "/multimanager-portfolio",
  },
  {
    title: "Total Returns Approach",
    text: "Looking beyond isolated investments.",
    desc: "We often see wealth fragmented across multiple managers, leading to imbalanced allocations and increased risk. Our Total Returns approach takes a holistic view — factoring in your overall wealth, broader risk profile, and return expectations. This ensures that decisions aren’t made in silos but in harmony with your long-term financial objectives.",
    link: "/proud-portfolio",
  },
  {
    title: "Consistent Outperformance",
    text: "Discipline drives results.",
    desc: "Our mission is to consistently outperform market benchmarks within each asset class we operate in. By following a disciplined, research-backed process, we minimise judgment errors and position our clients to capture growth while staying aligned with their risk appetite. It’s not just about returns — it’s about getting them the right way.",
    link: "/opportunities-portfolio",
  },
];

const Expertise = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  // 2. Initialize the navigate function
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".aboutStickySection");
      let index = 0;

      sections.forEach((section, i) => {
        const rect = section.getBoundingClientRect();
        if (
          rect.top < window.innerHeight * 0.75 &&
          rect.bottom > window.innerHeight * 0.15
        ) {
          index = i;
        }
      });

      setActiveIndex(index);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Function to handle the button click
  const handleReadMoreClick = (link) => {
    navigate(link);
  };

  return (
    <div className="aboutSticky">
      {expertise?.map((el, i) => (
        <div
          key={i}
          className={`aboutStickySection ${i === activeIndex ? "active" : ""}`}
        >
          <div className="content col-11 m-auto">
            <div className="col-md-6 col-11">
              <p>{`0${i + 1}`}</p>
              <p className="fs-3">{el?.title}</p>
              <p className="my-3">{el?.text}</p>
              <p className="tJustify">{el?.desc}</p>
              {/* 3. Attach the onClick handler to the button */}
              <button
                className="btn btn-outline-light rounded-0 border-2 mt-3"
                onClick={() => handleReadMoreClick(el?.link)} // Pass the link to the handler
              >
                Read More
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Expertise;
